import type { i18n } from 'i18next';
import { useTranslation } from 'next-i18next';

type Namespace = string | string[];

type TypedTFunction = (
  key: string,
  options?: { ns?: string; [key: string]: unknown }
) => string;

interface TypedTranslationHook {
  t: TypedTFunction;
  i18n: i18n;
  ready: boolean;
}

export function useTypedTranslation(ns?: Namespace): TypedTranslationHook {
  const { t: tOriginal, i18n, ready } = useTranslation(ns);
  const t = tOriginal as unknown as TypedTFunction;

  return { t, i18n, ready };
}
